import { render } from "./DialogStopSubscriptionDialog.vue?vue&type=template&id=ad23caa0"
import script from "./DialogStopSubscriptionDialog.vue?vue&type=script&lang=js"
export * from "./DialogStopSubscriptionDialog.vue?vue&type=script&lang=js"
script.render = render

export default script